import React, { useState } from 'react';

import { CheckIcon, CopyIcon } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';

interface BuildDetailsCopyL1IdsByTokensProps {
  title: string;
  tokenIds: string[];
}

export const BuildDetailsCopyIdsByTokens: React.FC<BuildDetailsCopyL1IdsByTokensProps> = ({ tokenIds, title }) => {
  const [isCopied, setIsCopied] = useState(false);

  return (
    <Button
      variant="secondary"
      className="font-roboto h-auto justify-start gap-1 p-1 px-2 text-sm"
      onClick={(e) => {
        e.stopPropagation();

        void navigator.clipboard.writeText(tokenIds.join('\n')).then(() => {
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 1000);
        });
      }}
    >
      {isCopied ? <CheckIcon className="size-4 text-green-500" /> : <CopyIcon className="size-4" />}
      {title}
    </Button>
  );
};
